// automatically generated by the FlatBuffers compiler, do not modify

import { ElevatorServiceMessage } from "../service/elevator-service-message";
import { EscalatorServiceMessage } from "../service/escalator-service-message";

export enum DeviceServiceContent {
	NONE = 0,
	ElevatorServiceMessage = 1,
	EscalatorServiceMessage = 2,
}

export function unionToDeviceServiceContent(
	type: DeviceServiceContent,
	accessor: (
		obj: ElevatorServiceMessage | EscalatorServiceMessage
	) => ElevatorServiceMessage | EscalatorServiceMessage | null
): ElevatorServiceMessage | EscalatorServiceMessage | null {
	switch (DeviceServiceContent[type]) {
		case "NONE":
			return null;
		case "ElevatorServiceMessage":
			return accessor(new ElevatorServiceMessage())! as ElevatorServiceMessage;
		case "EscalatorServiceMessage":
			return accessor(new EscalatorServiceMessage())! as EscalatorServiceMessage;
		default:
			return null;
	}
}

export function unionListToDeviceServiceContent(
	type: DeviceServiceContent,
	accessor: (
		index: number,
		obj: ElevatorServiceMessage | EscalatorServiceMessage
	) => ElevatorServiceMessage | EscalatorServiceMessage | null,
	index: number
): ElevatorServiceMessage | EscalatorServiceMessage | null {
	switch (DeviceServiceContent[type]) {
		case "NONE":
			return null;
		case "ElevatorServiceMessage":
			return accessor(index, new ElevatorServiceMessage())! as ElevatorServiceMessage;
		case "EscalatorServiceMessage":
			return accessor(index, new EscalatorServiceMessage())! as EscalatorServiceMessage;
		default:
			return null;
	}
}
